import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject, StreamAccessKey} from "../../../interfaces";
import {MaterialService} from "../../../classes/material.service";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService } from '@nebular/theme';

 
@Component({
  selector: 'app-stream-settings-access',
  templateUrl: './stream-settings-access.component.html',
  styleUrls: ['./stream-settings-access.component.scss'],
})
export class StreamSettingsAccessComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject

  levelLoading:boolean = false
  subscribeGetLevel: any = null
  subscribeGetAllKeys: any = null
  keyGeneratorQuantity: any = 0
  accessKeys: any = []
  accessLevels: any[] = [

    {text: "Відкрита трансляція", level: 0},
    {text: "Доступ за паролем", level: 1},
    {text: "Доступ після оплати", level: 2}

  ]

  streamAccessLevel: any = 0


   constructor(
    public streamsService: StreamsService,
    private _clipboardService: ClipboardService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService

    ){
  }
 

  openRemoveModal(content, e) {
    e.stopPropagation()
 	
    this.dialogService.open(content,{hasScroll: true} )
  }
  
  clearAllKeys(ref){

	ref.close()

    this.levelLoading = true
    this.streamsService.clearAllAccessKeys(this.stream._id).subscribe((keys:StreamAccessKey[])=>{
      
	this.accessKeys = []
      this.levelLoading = false

      this.toastrService.show('','Ключі видалено',{
        status: 'success',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })

    },()=>{

      this.levelLoading = false
      
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }
 

  genereteKeys(){


    if( this.keyGeneratorQuantity > 0){
      this.levelLoading = true
      this.streamsService.generateAccessKeys(this.stream._id, this.keyGeneratorQuantity)
      .subscribe((keys:StreamAccessKey[])=>{
         var temp = {time: keys[0].created, keys:[]}
       
       
        for(let key of keys){
          temp.keys.push(key)
        }
        this.accessKeys.push(temp) 

        this.levelLoading = false
         
        this.toastrService.show('','Ключі створено',{
          status: 'primary',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
        this.keyGeneratorQuantity = 0
      },(error)=>{
        this.levelLoading = false
      
        this.toastrService.show('','Сталася помилка сервера',{
          status: 'danger',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
      })
   } else {
         
        this.toastrService.show('','Кількість має бути більшою за нуль',{
          status: 'danger',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
   }
   
  }


  loadKeys(){

    this.subscribeGetAllKeys = this.streamsService.getAllAccessKeys(this.stream._id).subscribe((keys: StreamAccessKey[])=>{

      var allKeys = []
      var temp = <any>{}
      var before = null
      for(let key of keys){
        if(before !== key.created){
          temp = <any>{time:key.created, keys: [] }
          allKeys.push(temp)
        }
        temp.keys.push(key)
        before = key.created
      }

      this.accessKeys = allKeys

    })

  }


  setAccessLevel(level){
    if(this.streamAccessLevel === level || level === 2){
      return
    }

    this.levelLoading = true
    this.subscribeGetLevel = this.streamsService.setAccessLevel(this.stream._id, level).subscribe((stream: StreamProject)=>{
      this.streamAccessLevel = stream.accessLevel
      this.stream.accessLevel = stream.accessLevel
      this.levelLoading = false
    },(error)=>{
      this.levelLoading = false
  
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


  ngOnInit() { 
    this.streamAccessLevel = this.stream.accessLevel
    this.loadKeys()

  }

  
   ngOnDestroy() { 
    if( this.subscribeGetLevel){
      this.subscribeGetLevel.unsubscribe()
     }
    if( this.subscribeGetAllKeys){
      this.subscribeGetAllKeys.unsubscribe()
      
    }

    //subscribeGetAllKeys
   }
 

   


   copyAllKeysToClipboard(ref){
    this._clipboardService.copy(ref.innerText)



    this.toastrService.show('','Скопійовано в буфер обміну',{
      status: 'primary',
      icon:'',
      position: <NbGlobalPosition>'bottom-right'
        })
   }
   
   downloadAllKeysInTxt(ref){
      this.saveTextAsFile( ref.innerText, `${this.stream.streamKey}_keys.txt`)
   }


     saveTextAsFile (data, filename){

    if(!data) {
        console.error('Console.save: No data')
        return;
    }

    if(!filename) filename = 'file.txt'
	
	 

    var blob = new Blob([data], {type: 'text/plain'}),
        e    = document.createEvent('MouseEvents'),
        a    = document.createElement('a')
 

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else{
          var e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
         /* e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null); */
		e.initEvent('click')
          a.dispatchEvent(e);
        }
  }

 

  
}
